module.exports = __webpack_public_path__ + "img/slide_1.e9d60afa.png";